module.exports = __webpack_public_path__ + "static/media/driver.a33cefdd.png";